module.exports = __webpack_public_path__ + "img/calendario.185490c9.png";